/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Notifications from 'vue-notification';
import VModal from 'vue-js-modal';
import eventPathPolyfill from '@/utils/eventPathPolyfill';
import createApp from './app';

eventPathPolyfill();

function setViewport() {
  const width = (window.orientation === 0 || window.orientation === 180)
    ? window.screen.width : window.screen.height;

  if (width < 1250 && window.screen.width > 767 && window.screen.height > 767) {
    document.querySelector('meta[name=viewport]').setAttribute('content', `width=device-width,initial-scale=${width / 1250}`);
  }
}
setViewport();
window.addEventListener('resize', setViewport);
window.addEventListener('orientationchange', setViewport);

Vue.use(Notifications);
Vue.use(VModal);

const { app } = createApp();

app.$mount('#app');
